/** 前台文件下载失败文案映射（设计：2026-08-13-前台文件下载错误提示） */
export const DOWNLOAD_MSG_NETWORK = '文件下载失败，请稍后再试'
export const DOWNLOAD_MSG_MISSING = '文件丢失，请联系管理员重新上传'
export const DOWNLOAD_MSG_SYSTEM = '系统出现问题，请联系系统运维人员'

const MISSING_HINT = /不存在|已下线|已删除|文件丢失|地址不存在|找不到|not\s*found/i
const NETWORK_HINT = /network|failed to fetch|load failed|networkerror|超时|网络|ECONN|ERR_NETWORK|aborted|abort/i

function pickStatus(error) {
  if (error == null) return undefined
  if (typeof error === 'number') return error
  if (typeof error === 'object') {
    const s = error.status != null ? error.status : error.code
    const n = Number(s)
    return Number.isFinite(n) ? n : undefined
  }
  return undefined
}

function pickMessage(error) {
  if (error == null) return ''
  if (typeof error === 'string') return error
  if (typeof error === 'object') {
    return String(error.message || error.msg || '')
  }
  return String(error)
}

/**
 * @param {Error|{status?:number,code?:number,message?:string,msg?:string}|string|null|undefined} error
 * @returns {string}
 */
export function resolveDownloadErrorMessage(error) {
  const status = pickStatus(error)
  const message = pickMessage(error)

  if (status === 401 || status === 403) {
    return message || (status === 403 ? '无权下载该文件' : '请登录后下载')
  }

  if (status === 0 || status === undefined || status === null) {
    if (!message || NETWORK_HINT.test(message) || (error && error.name === 'TypeError')) {
      return DOWNLOAD_MSG_NETWORK
    }
  }

  if (status === 404 || MISSING_HINT.test(message)) {
    return DOWNLOAD_MSG_MISSING
  }

  if (status != null && status >= 500) {
    return DOWNLOAD_MSG_SYSTEM
  }

  if (NETWORK_HINT.test(message)) {
    return DOWNLOAD_MSG_NETWORK
  }

  if (MISSING_HINT.test(message)) {
    return DOWNLOAD_MSG_MISSING
  }

  return DOWNLOAD_MSG_SYSTEM
}
